<button nbButton ghost size="tiny"
        [nbContextMenu]="items"
        [nbContextMenuTag]="contextTag"
        aria-label="More actions">
  <nb-icon icon="more-vertical" status="primary" pack="eva"></nb-icon>
</button>
